export default function PHP_getDocNamespaces() {
  return (
    <div>
      <h1>PHP_getDocNamespaces</h1>
    </div>
  );
}
